// extracted by mini-css-extract-plugin
export default {"container":"sideMenu_container__18XQo","hidden":"sideMenu_hidden__2GZEJ","content":"sideMenu_content__NAbQ5","toggleButton":"sideMenu_toggleButton__qTwR9"};